/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface RichWindow extends Window {
    heap: any;
    Tally: any;
  }
}

export const RichWindow: RichWindow = window as unknown as RichWindow;
